import { render, staticRenderFns } from "./contentsListComponent.vue?vue&type=template&id=1f3de78e&"
import script from "./contentsListComponent.vue?vue&type=script&lang=ts&"
export * from "./contentsListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./contentsListComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports